import React from 'react';
interface FooterProps {
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
}
export function Footer({
  onOpenPrivacy,
  onOpenTerms
}: FooterProps) {
  return <footer className="bg-earth-900 text-cream-100/80 py-6 border-t border-earth-700" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-6" data-id="element-62">
          <div className="flex items-start gap-4 md:max-w-md" data-id="element-63">
            <img src="https://cdn.magicpatterns.com/uploads/eTAB2jSXKMJTwmP6VD8iA3/FEBFB789-B4DB-40E8-BB0A-4BC650B55AAD.png" alt="Pancho's Lawn Care Logo" className="h-14 shrink-0" data-id="element-64" />
            <p className="text-cream-100/70 text-sm leading-relaxed" data-id="element-65">
              Professional landscaping services with 12+ years of experience.
              Serving Northern Illinois and Southern Wisconsin with pride and
              personal accountability.
            </p>
          </div>

          <div className="flex items-center gap-4 text-sm flex-wrap" data-id="element-66">
            <a href="mailto:franvillalva198@gmail.com" className="hover:text-white transition-colors whitespace-nowrap" data-id="element-67">
              franvillalva198@gmail.com
            </a>
            <span className="text-white/20" data-id="element-68">|</span>
            <button onClick={onOpenPrivacy} className="hover:text-white transition-colors whitespace-nowrap" data-id="element-69">
              Privacy Policy
            </button>
            <span className="text-white/20" data-id="element-70">|</span>
            <button onClick={onOpenTerms} className="hover:text-white transition-colors whitespace-nowrap" data-id="element-71">
              Terms of Service
            </button>
          </div>
        </div>

        <div className="pt-4 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-cream-100/50" data-id="element-72">
          <p data-id="element-73">
            © {new Date().getFullYear()} Pancho's Lawn Care. All rights
            reserved.
          </p>
          <p className="font-medium italic" data-id="element-74">
            Built on Reputation, One Yard at a Time
          </p>
        </div>
      </div>
    </footer>;
}